listHandler = {
  $selectAlpha:       $('[href="#select-alpha"]'),
  $selectPage:        $('[href="#select-page"]'),
  //$gridContentActive: $('.grid-content:not(.hide)'),
  $gridContent:       $('.grid-content'),
  $counter:           $('.show-count-container .counter'),
  $label:             $('.show-count-container .list-type'),
  $openChild:         $('.open-child'),
  
  changeAlpha: function(){
    var self = this;

    this.$selectAlpha.on('click', function(e){
      e.preventDefault();
      var alpha = $(this).data('alpha');
      var $selectedGridContent = $('.grid-content[data-alpha="'+alpha+'"]');
      
      self.$gridContent.addClass('hide');
      self.$selectAlpha.removeClass('is-selected');
      
      $(this).addClass('is-selected');
      $selectedGridContent.removeClass('hide');
      
      //self.$counter.html($selectedGridContent.find('.item:not(.hide)').length)
      self.countVisibleData($selectedGridContent);

      // Focus to the first item
      $selectedGridContent.find('.item-name:first').get(0).focus()
    })

    // Keyboard shortcut for alphabet
    this.$selectAlpha.on('keydown', function(e) {
      // When user pressed alphabet keys or numeric keys
      if ((e.keyCode >= 65 && e.keyCode <= 90) || (event.keyCode >= 49 && event.keyCode <= 57)) {
        var alpha = e.key.toUpperCase()
        var $alpha = $('[data-alpha='+ alpha +']')
        if ($alpha.length > 0) {
          $alpha.trigger('click')
        }
      }
    });

    // When Esc key pressed on item name, switch focus to the alphabet list
    $('.grid-content .item-name').on('keydown', function(e) {
      if (e.key === 'Escape') {
        var $grid = $(this).closest('.grid-content'),
          alpha = $grid.data('alpha');
        
        $('.alphabet-content').children('[data-alpha="'+ alpha +'"]').get(0).focus()
      }
    })
  },

  countVisibleData: function($content=null){
    let length = 0;
    if ($content) {
      length = $content.find('.item:not(.hide)').length;
    } else {
      length = $('.grid-content:not(.hide)').find('.item:not(.hide)').length;
    }
    let text_counter = length+' ';
    let label = this.$label.html();
    if (label == 'country') {
      text_counter += ((length > 1) ? 'countries' : label);    
    } else {
      text_counter += label+((length > 1) ? 's' : '');
    }

    this.$counter.html(text_counter);
    
  },

  simplerPaging: function(){
    let counter     = 1;
    let $gridContent    = $('.grid-content:not(.hide)');
    let $itemPaging     = $gridContent.find('.item-paging');
    let $itemLastPaging = $gridContent.find('.item-paging.last');
    let lastPage    = $itemLastPaging.data('page'); 
    let state       = false;
    let limit       = 6;
    
    $itemPaging.removeClass('hide');
    $itemPaging.removeClass('dotted');
    $itemPaging.each(function(){
      if ((!$(this).hasClass('first')) && (!$(this).hasClass('last'))) {
        if ($(this).hasClass('active')) {
          state = true;
        }

        if (state) {
          if ((counter == 5) && (counter < lastPage)) {
            $(this).addClass('dotted');
          } else if ((counter > 5) && (counter < lastPage)) {
            $(this).addClass('hide');
          } 
          
          counter++;
        } else {
          $(this).addClass('hide');
        }
      }
    })

    let $itemPagingActive = $gridContent.find('.item-paging.active');
    if (counter < limit) {
      let activePage = $itemPagingActive.data('page');
      let loopI      = limit - counter; 
      let startI     = (activePage - loopI);

      for (let i = startI ; i < activePage; i++) {
        $gridContent.find('.item-paging[data-page='+i+']').removeClass('hide');
      }
    }
        
    $itemLastPaging.prev().removeClass('hide');
    $itemLastPaging.prev().removeClass('dotted');
  },

  pagingBehaviour: function(){
    var self = this;
    
    this.$selectPage.on('click', function(e){
      e.preventDefault();
      let page = $(this).data('page'); 
      
      $(this).parent().children().removeClass('active');
      if ($(this).hasClass('first')) {
        $(this).next().addClass('active');
      
      } else if ($(this).hasClass('last')) {
        $(this).prev().addClass('active');
      
      } else {
        $(this).addClass('active');
      }
      
      $(this).closest('.grid-content').find('.item').addClass('hide');
      $(this).closest('.grid-content').find('.item[data-page="'+page+'"]').removeClass('hide');
      self.countVisibleData();
      self.simplerPaging();
    });
  },

  listChild: function(){
    var self = this;

    this.$openChild.on('click', function(e) {
      $(this).toggleClass('is-active');
      $(this).children().toggleClass('is-active');
      $(this).next().toggleClass('is-active');
      //$('[data-masonry]').masonry( 'layout' );
    })
  },

  init: function(){
    var self = this;
    this.changeAlpha();
    this.pagingBehaviour();
    this.countVisibleData();
    this.simplerPaging();
    this.listChild();
  }
}